module.exports = __webpack_public_path__ + "img/plus-solid.ad8dc961.svg";